module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/mainBg_2c667e39d55a50ae81e034855bf95a10.jpg";